import { Stack, Box, Text } from 'braid-design-system';
import type { ReactElement, ComponentProps, FC } from 'react';

import { Display } from 'src/libs/Display';

interface EmptyStateLayoutProps {
  icon: ReactElement;
  messageHeading: string;
  children?: ComponentProps<typeof Stack>['children'];
}
export const EmptyStateLayout: FC<EmptyStateLayoutProps> = ({
  icon,
  children,
  messageHeading,
}) => (
  <Box
    background="surface"
    paddingX={['gutter', 'xxlarge', 'xxxlarge']}
    paddingY={['large', 'xlarge']}
    display="flex"
    justifyContent="center"
    alignItems="center"
    borderRadius="standard"
  >
    <Box maxWidth="small">
      <Stack space="large" align="center">
        {icon}
        <Stack space={['medium', 'medium', 'gutter']} align="center">
          <Display mobile tablet>
            <Text size="standard" weight="strong" align="center" component="h4">
              {messageHeading}
            </Text>
          </Display>
          <Display desktop>
            <Text size="large" weight="strong" align="center" component="h4">
              {messageHeading}
            </Text>
          </Display>
          {children}
        </Stack>
      </Stack>
    </Box>
  </Box>
);
